// extracted by mini-css-extract-plugin
export default {"container":"ZF-z","modal":"_F-z","dimensions":"aG-z","brandName":"bG-z","productName":"cG-z","labelValue":"dG-z","recipientEmail":"eG-z","recommendedFit":"fG-z","hiddenField":"gG-z"};